import React, { useState, useEffect, useRef } from "react";
import {useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../redux/AuthSlice";
import { PersonCircle } from "react-bootstrap-icons";
import ProfileModal from "./models/ProfileModal";
import ChangePasswordModal from "./models/ChangePasswordModal";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="header">
      <h2>Super Admin</h2>
      <div
        className={`user-profile ${dropdownOpen ? "open" : ""}`}
        ref={dropdownRef}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            setDropdownOpen((prev) => !prev);
          }}
          className="profile-btn"
        >
          <PersonCircle size={30} />
        </button>
        <ul className="dropdown-menu">
          <li>
            <button onClick={() => setShowProfileModal(true)} className="dropdown-item">
              Profile
            </button>
          </li>
          <li>
            <button onClick={() => setShowChangePasswordModal(true)} className="dropdown-item">
              Change Password
            </button>
          </li>
          <li>
            <button onClick={handleLogout} className="dropdown-item logout-btn">
              Logout
            </button>
          </li>
        </ul>
      </div>
      {showProfileModal && <ProfileModal onClose={() => setShowProfileModal(false)} />}
      {showChangePasswordModal && <ChangePasswordModal onClose={() => setShowChangePasswordModal(false)} />}
    </header>
  );
};

export default Header;